import {
  DecodedBffConfigurationParameters,
  formatMockIds,
} from '@volkswagen-onehub/vw-e-mobility-service-responses';

export const encodeBffConfigParameters = ({
  language,
  countryCode,
  featureAppName,
  serviceConfigEndpointProvider,
  mockIds,
  cacheBuster,
  debug,
  options,
}: DecodedBffConfigurationParameters): URLSearchParams => {
  return new URLSearchParams({
    language,
    countryCode,
    ...(serviceConfigEndpointProvider && {
      serviceConfigEndpointProvider: JSON.stringify(
        serviceConfigEndpointProvider
      ),
      ...(featureAppName && {featureAppName}),
      ...(mockIds.size > 0 && {mockIds: formatMockIds(mockIds)}),
      ...(cacheBuster && {cacheBuster}),
      ...(debug && {debug}),
      ...(options && {options: JSON.stringify(options)}),
    }),
  });
};
